<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card
          class="ma-3 col-sm-6" outlined
      >
        <v-card-title>Create Outlet IP</v-card-title>
        <hr class="ma-1">
        <div class="col">
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <v-text-field
                v-model="name"
                :rules="nameRules"
                label="Name"
                required
            ></v-text-field>

            <v-text-field
                v-model="ip"
                label="IP"
            ></v-text-field>

            <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4 font-weight-bold"
                @click="submit"
            >
              Save
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    valid: true,
    name: '',
    nameRules: [
      v => !!v || 'Name is required',
    ],
    ip: '',
    breadcrumbsItems: '',
  }),
  props: ['outlet'],
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    }
  },
  methods: {
    submit() {
      let outlet = this.outlet;
      if (this.$refs.form.validate()) {
        axios.post('/outlet/' + this.outlet.id + '/ip', {
          name: this.name,
          ip: this.ip,
        }).then(function (result) {
          window.location.href = '/outlet/' + outlet.id;
        });
      }
    }
  },
  beforeMount() {
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: false,
        href: '/outlet/' + this.outlet.id + '/edit',
        link: true,
        text: this.outlet.name,
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: this.outlet.name + ' Printer IP',
      },
    ];
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/OutletIPs/OutletIPCreate.vue